import * as React from 'react';
import styled from 'styled-components';
import { DSTableProps, DSTable } from './DSTable';

export interface DSDecoratedTableProps extends Omit<DSTableProps, 'component'> {
    $striped?: boolean;
    $condensed?: boolean;
}

export const DSDecoratedTable: React.FC<DSDecoratedTableProps> = styled(DSTable)<DSDecoratedTableProps>`
    ${props =>
        props.$striped
            ? `
                tbody {
                    tr {
                        &:nth-of-type(odd) {
                            background-color: ${props.theme.palette.action.hover} !important;
                        }
                    }
                }
            `
            : ''}

    ${props =>
        props.$condensed
            ? `
                tbody {
                    tr {
                        td, th {
                            padding-top: 5px;
                            padding-bottom: 5px;
                        }
                    }
                }
            `
            : ''}
`;
DSDecoratedTable.displayName = 'DSDecoratedTable';
